import request from 'utils/request'
/*---------  客户管理中心详情    -------*/
//客户概览
export const getCustomerOverview = id => request().get(`customer/query/${id}`)
